<script>
	import { onMount } from 'svelte'
	import { fade } from 'svelte/transition'
	import lozad from 'lozad'
	// export let coords = []
    // {
    //     long:"26.52058848208656",
    //     lat:"-81.86991474243017"
    // }
	//Define map node element
	let mapEl
	//Define map on load
	let map
	onMount(() => {
		//onMount runs on page load
		//Define Mapbox Access Token
		L.mapbox.accessToken =
			'pk.eyJ1IjoianRnYm9vc3QiLCJhIjoiY2twOGZuczNuMDNsYTJ3cDBpNWlqNHZvMiJ9.EdiJ1DiGh4Jl_S297h-hsg'
		//Create map element, set coordinates, add map styles, and bind it to map node
		map = L.mapbox
			.map(mapEl)
            //!
			.setView([26.52058848208656, -81.86991474243017], 15)
			//!.setView([coords.long, coords.lat], 20)
			.addLayer(
				L.mapbox.styleLayer(
					'mapbox://styles/jtgboost/ckp8h566e1b2918nvw9uwr9wx'
				)
			)
		map.scrollWheelZoom.disable()
		// fit map to markers
        // map.fitBounds([[26.52058848208656, -81.86841474243017]], { maxZoom: 14 })
		//set position of zoom control
		map.zoomControl.setPosition('bottomright')
        let ratio = 2218 / 1469
        let width = 43
        const icon = L.icon({
            iconUrl: '/wp-content/uploads/2021/05/pin.png',
            //1469 by 2218
            iconSize: [width, Math.round(ratio * width)],
            iconAnchor: [22, 54],
            popupAnchor: [0, -59],
        })
        let marker = new L.marker([26.52058848208656, -81.86991474243017], { icon })
        map.addLayer(marker)
	})
</script>

<div class="hero-map" bind:this={mapEl} data-slideout-ignore />